import { getProjectId, postProjectId, deleteProjectById, getProjectIdById } from './template_crud';

const path = '/certificates'
export const getCertificates = getProjectId(path);
export const getCertificatesById = getProjectIdById(path);
export const addCertificates = postProjectId(path);
export const delCertificates = deleteProjectById(path)
